import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-container" id="about-me">
      <div className="about-main">
        <div className="about-left">
          <hr width="300"></hr>
          <h1>About Me.</h1>
        </div>
        <div className="about-right">
          <p className="resP-About">
            I'm Nicolas Alanis, i'm 33 years old. Currently student of the
            Computer Systems Analyst career at Institucion Cervantes. I consider
            myself a responsible, orderly and punctual person with the ability
            to work as a team.
          </p>
          <p>
            Throughout my training, I've enhanced my knowledge in the languages
            of C#, JavaScript, CSS, HTML, React and SQL as well as in the
            English language at the Faculty of Languages of the National
            University of Córdoba.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
